import { EditorState } from '../Editor.types';
import { getActiveEntities } from '../utils/entities';
import { AulaEntity } from '../Entities';
import { hasFailedUpload } from './hasFailedUpload';
import { isInSelectionMode } from './hasUnselectedLtiContent';

/**
 * Computes whether an EditorState's blocks has errors
 */
export const hasError = (editorState: EditorState): boolean =>
  Object.values(getActiveEntities(editorState)).some(
    (aulaEntity: AulaEntity) =>
      aulaEntity &&
      (hasFailedUpload(aulaEntity) || isInSelectionMode(aulaEntity)),
  );
